import { MultiselectOption as OptionInterface } from '@app/shared/components/multiselect/multiselect-option';

export class MultiselectOption<T> implements OptionInterface<T> {
  constructor(public label: string, public value: T, public isSelected: boolean = false) {}
}
